import {
  mdiCheckAll,
} from '@mdi/js';

export default {
  data() {
    return {
      mdiCheckAll,
    };
  },
  methods: {
    cannedMenuItems(item) {
      return [{
        title: '1. Process Check Sheet',
        to: {
          name: 'processing-EditProcessCheckSheet',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: '2. In Line Quality Checks',
        to: {
          name: 'processing-EditInLineQualityCheck',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: '3. Can&Can End Inspection',
        to: {
          name: 'processing-EditCanEndInspection',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: '4. Canning Process',
        to: {
          name: 'processing-EditCanningProcess',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: '5. Batch Printing Verifications',
        to: {
          name: 'processing-EditBatchPrintingVerification',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: '6. Recipe Verification',
        to: {
          name: 'processing-EditRecipeVerification',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: '7. PDF Documents',
        to: {
          name: 'processing-StockItemFiles',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }];
    },
    driedMenuItems(item) {
      return [{
        title: 'PDF Documents',
        to: {
          name: 'processing-StockItemFiles',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: 'Process Check Sheet',
        to: {
          name: 'processing-EditProcessCheckSheet',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: 'Pre-Cooked Weights',
        to: {
          name: 'processing-EditDriedAbaloneSummary',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: 'Dried Cooking Process Check',
        to: {
          name: 'processing-EditDriedCookingProcessCheck',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: 'Dried Abalone Cooking Sheet',
        to: {
          name: 'processing-EditDriedAbaloneCookingSheet',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }];
    },
    pouchesMenuItems(item) {
      return [{
        title: 'PDF Documents',
        to: {
          name: 'processing-StockItemFiles',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: 'Process Check Sheet',
        to: {
          name: 'processing-EditProcessCheckSheet',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }, {
        title: 'Receiving Cultivated Abolene',
        to: {
          name: 'processing-EditReceivingOfCultivatedAbolone',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }];
    },
    undefinedMenuItems(item) {
      return [{
        title: 'Process Check Sheet',
        to: {
          name: 'processing-EditUndefinedProcessChecksheet',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }];
    },
    wetMenuItems(item) {
      return [{
        title: 'Process Check Sheet',
        to: {
          name: 'processing-EditProcessCheckSheet',
          query: { stockItemId: item.id },
        },
        icon: mdiCheckAll,
      }];
    },
    getStockTypeMenuItems(item) {
      const {
        cannedMenuItems, driedMenuItems, pouchesMenuItems, undefinedMenuItems, wetMenuItems,
      } = this;
      let menuItems = [];
      switch (item.stockType) {
        case 'Canned':
          menuItems = cannedMenuItems(item);
          break;
        case 'Wet':
          menuItems = wetMenuItems(item);
          break;
        case 'Dried':
        case 'Dry':
          menuItems = driedMenuItems(item);
          break;
        case 'Pouches':
          menuItems = pouchesMenuItems(item);
          break;
        case 'Split':
        case 'Undefined':
          menuItems = undefinedMenuItems(item);
          break;
        default:
          menuItems = [];
          break;
      }
      return menuItems;
    },
  },
};
